export const SET_ROSTER_PROCESS_FORMDATA = 'SET_ROSTER_PROCESS_FORMDATA';
export const SET_BULK_ROSTER_PROCESS_FORMDATA = 'SET_BULK_ROSTER_PROCESS_FORMDATA';
export const RESET_ROSTER_PROCESS_FORMDATA = 'RESET_ROSTER_PROCESS_FORMDATA';
export const SET_ROSTER_STEP_FORMDATA = 'SET_ROSTER_STEP_FORMDATA';
export const SET_BULK_ROSTER_STEP_FORMDATA = 'SET_BULK_ROSTER_STEP_FORMDATA';
export const RESET_ROSTER_STEP_FORMDATA = 'RESET_ROSTER_STEP_FORMDATA';
export const CHANGE_RESET_STEP_ORDER = 'CHANGE_RESET_STEP_ORDER';
